import { useState, useCallback, useEffect } from 'react';
import { getAvailableYears } from '../services/quotasService';

export const useAvailableYears = () => {
  const [availableYears, setAvailableYears] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAvailableYears = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await getAvailableYears();
      
      if (response?.error) {
        throw new Error(response.message || 'Error al obtener años disponibles');
      }

      let yearsArray = Array.isArray(response) ? response : [];
      const currentYear = new Date().getFullYear();

      // Asegurar que el año actual siempre esté incluido
      if (!yearsArray.includes(currentYear)) {
        yearsArray.push(currentYear);
      }

      // Ordenar los años de forma descendente (más reciente primero)
      yearsArray.sort((a, b) => b - a);

      setAvailableYears(yearsArray);
    } catch (err) {
      setError(err.message);
      setAvailableYears([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAvailableYears();
  }, [loadAvailableYears]);

  return { availableYears, isLoading, error, refetch: loadAvailableYears };
};
